"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutSummary() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="py-16 transition-all duration-[var(--duration-medium)] opacity-100 translate-y-0 !bg-[hsl(0,0%,98%)] md:py-24">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          {}
          <div className="space-y-4">
            <h2 className="font-display text-4xl font-bold leading-tight !text-[hsl(22,78%,26%)] !text-center md:text-5xl">
              Trusted Auditing Expertise in Dubai
            </h2>
            <p className="text-base leading-relaxed !text-justify !text-[hsl(0,0%,0%)] md:text-lg">
              Salem Ballama Auditing combines professional authority with deep local market expertise to deliver comprehensive financial services across the UAE. Our firm specializes in audit & assurance, tax advisory, financial consulting, and regulatory compliance.
            </p>
            <p className="text-base leading-relaxed !text-justify !text-[hsl(0,0%,0%)] md:text-lg">With bilingual support in English and Arabic, we serve high-net-worth individuals and corporate entities, ensuring accuracy in every aspect of financial terminology and compliance. Our commitment to the "Gold Standard" of corporate excellence makes us the preferred partner for dealing with Dubai's regulatory landscape.</p>
            <p className="text-base leading-relaxed !text-justify !text-[hsl(0,0%,0%)] md:text-lg">
              From statutory audits to ESR and AML compliance, our team delivers seamless booking funnels and expert guidance tailored to your unique needs.
            </p>
          </div>

          {}
          <div className="flex justify-center md:justify-end">
            <div className="relative w-full max-w-md">
              <img src="https://rational-stag.10web.cloud/wp-content/uploads/2026/01/salem_ballama_office_dubai.webp" alt="Salem Ballama Auditing Partners" className="w-full rounded-lg shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] !h-[600px] hover:shadow-strong hover:-translate-y-[3px]" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}